<template>
  <div>
    <div class="flex justify-between">
      <div v-if="setting.accounts !== undefined" class="font-bold w-full">{{ setting.accounts.firm_name || '__' }}</div>
      <div v-if="items.record && items.record.to_contact" class="font-bold w-full">Client: {{ items.record.to_contact.person ? `${items.record.to_contact.person.first_name} ${items.record.to_contact.person.last_name}` : items.record.to_contact.company.name }}</div>
    </div>
    <div class="flex flex-col justify-between description-bill">
      <div class="flex justify-between">
          <a-descriptions v-if="setting && setting.accounts !== undefined" class="description-bill-company" :column="1">
            <a-descriptions-item label="Address">{{ setting.accounts.street || '__' }}</a-descriptions-item>
            <a-descriptions-item label="City">{{ setting.accounts.city || '__' }}</a-descriptions-item>
            <a-descriptions-item label="State">{{ setting.accounts.state  || '__'}}</a-descriptions-item>
            <a-descriptions-item label="Post Code">{{ setting.accounts.post_code || '__' }}</a-descriptions-item>
            <a-descriptions-item label="Country">{{ setting.accounts.country || '__' }}</a-descriptions-item>
            <a-descriptions-item label="Tel">
              {{ setting.accounts.phone || '__' }}
            </a-descriptions-item>
            <a-descriptions-item label="Fax">{{ setting.accounts.fax || '__' }}</a-descriptions-item>
            <a-descriptions-item label="Email">{{ setting.accounts.contact_email || '__' }}</a-descriptions-item>
            <a-descriptions-item label="Web">{{ setting.accounts.contact_website || '__' }}</a-descriptions-item>
<!--            <a-descriptions-item id="amount-due" label="Amount Due">-->
<!--              <strong>{{ currencySymbol + (items.record.total_amount - items.record.payed_amount) }}</strong>-->
<!--            </a-descriptions-item>-->
          </a-descriptions>
          <a-descriptions v-if="items.record && items.record.to_contact" class="description-bill-company" :column="1">
            <a-descriptions-item v-if="items.record.to_contact.addresses.length" label="Address">{{ items.record.to_contact.addresses[0].street }}</a-descriptions-item>
            <a-descriptions-item v-if="items.record.to_contact.addresses.length" label="City">{{ items.record.to_contact.addresses[0].city }}</a-descriptions-item>
            <a-descriptions-item v-if="items.record.to_contact.addresses.length" label="State">{{ items.record.to_contact.addresses[0].state }}</a-descriptions-item>
            <a-descriptions-item v-if="items.record.to_contact.addresses.length" label="Country">{{ items.record.to_contact.addresses[0].country_name }}</a-descriptions-item>
            <a-descriptions-item v-if="items.record.to_contact.phones.length" label="Tel">{{ items.record.to_contact.phones[0].phone_number }}</a-descriptions-item>
            <a-descriptions-item v-if="items.record.to_contact.emails.length" label="Email">{{ items.record.to_contact.emails[0].email_address }}</a-descriptions-item>
            <a-descriptions-item label="Amount Due">{{ currencySymbol }}{{ amountDue }}</a-descriptions-item>
          </a-descriptions>
        </div>
    </div>

    <!--
    tbl-header-temp: this class on the a-table makes the footer at 50% size
    -->
    <a-table
      class="mt-5"
      :columns="columns"
      :data-source="listTable"
      :pagination="false"
      :row-selection="rowSelectionSettings"
    >
      <template slot="footer">
        <div class="flex flex-col space-y-2" style="width: 65%; margin-inline-start: auto;">
          <!-- <div v-if="dataSource.length && isBillTaxable" class="flex justify-between"> -->
            <!-- <div>Total:</div> -->
            <!-- <div>{{ currencySymbol + (items.record.type === 1 ? (totalAmountTimesExpense(dataSource[0])).toFixed(2) : items.data.total) }}</div> -->
           <!-- <div>{{ currencySymbol + (totalAmountTimesExpense(dataSource[0])).toFixed(2) }}</div> -->
          <!-- </div> -->
          <div class="flex justify-between items-center" v-if="items.record.type === BILLING_TYPE_BILL">
            <div>Total Amount (Excl. Tax):</div>
            <div>{{ currencySymbol + (listTable.reduce((result, el) => result += (el.total ? el.total : 0), 0)).toFixed(2) }}</div>
          </div>
          <div 
            v-if="!(this.items.record.status === STATUS_APPROVED && this.discountList.filter(el => el.value > 0).length === 0) && items.record.type === BILLING_TYPE_BILL"
            class="flex justify-between items-center"
          >
            <div>Discount:</div>
            <div v-if="isBillOld">{{ currencySymbol + items.record.discount }}</div>
            <div v-else>{{ currencySymbol + totalDiscountAmount }}</div>
          </div>
          <div class="flex justify-between items-center" v-if="items.record.type === BILLING_TYPE_BILL">
            <div>Total Tax Amount:</div>
            <div>{{ currencySymbol + totalTaxAmount }}</div>
          </div>
          <div class="flex justify-between items-center font-bold">
            <div v-if="items.record.type === BILLING_TYPE_BILL">Total Amount (Incl. Tax):</div>
            <div v-if="items.record.type === BILLING_TYPE_FUND_REQUEST">Total Amount:</div>
            <div>{{ currencySymbol + amountDue }}</div>
          </div>
          <!-- <div v-if="isBillTaxable" class="flex justify-between items-center">
            <div>{{ (setting.tax !== undefined ? setting.tax.rate : DEFAULT_TAX_RATE) + '%' }} {{ setting.tax !== undefined ? setting.tax.type : 'SST' }}</div>
            <div>{{ currencySymbol + (getTaxAmount(dataSource[0]) * (setting.tax !== undefined ? setting.tax.rate : DEFAULT_TAX_RATE) /100).toFixed(2) }}</div>
          </div> -->
          <a-button
            v-if="items.record.status === STATUS_DRAFT"
            class="mt-10"
            type="primary"
            @click="handleSubmitDiscount"
            :loading="loading"
            :disabled="items.record.type === BILLING_TYPE_FUND_REQUEST"
          >
            Save
          </a-button>
        </div>
      </template> <!-- END TABLE FOOTER -->
      
      <span slot="matter" slot-scope="text, record">
        <a-popover>
          <template slot="content">
            <p>{{ record.matter }}</p>
          </template>
          <span style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden; width: 25rem; text-align: left;">
            {{ record.matter }}
          </span>
        </a-popover>
      </span>
      <span slot="amount" slot-scope="text, record" style="white-space: nowrap;">
        {{ currencySymbol + (record.total ? record.total.toFixed(2) : '0.00') }}
      </span>
      <span slot="taxed_amount" slot-scope="text, record" style="white-space: nowrap;">
        <span v-if="isBillOld">-</span>
        <span v-else-if="selectedRowKeys.includes(record.row - 1)">
          {{ currencySymbol + (record.total ? ((record.total - discountList[record.row - 1].value) * (setting.tax.rate / 100)).toFixed(2) : '0.00') }}
        </span>
        <span v-else>{{ currencySymbol + '0.00' }}</span>
      </span>
      <span slot="amount_plus_taxed_amount" slot-scope="text, record" style="white-space: nowrap;">
        <span v-if="isBillOld">-</span>
        <span v-else-if="selectedRowKeys.includes(record.row - 1)">
          {{ currencySymbol + (record.total ? (((record.total - discountList[record.row - 1].value) * setting.tax.rate / 100) + (record.total - discountList[record.row - 1].value)).toFixed(2) : '0.00') }}
        </span>
        <span v-else>
          {{ currencySymbol + (record.total ? (record.total - discountList[record.row - 1].value).toFixed(2) : '0.00') }}
        </span>
      </span>
      <span slot="price" slot-scope="text, record" style="white-space: nowrap;">
        {{ currencySymbol + (record.rate ? record.rate.toFixed(2) : '0.00') }}
      </span>
      <span slot="description" slot-scope="text, record">
        <div v-if="record.category" class="font-bold">
          <a-popover>
            <template slot="content">
              <p>{{ record.category.name }}</p>
            </template>
            <span style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden; width: 25rem; text-align: left;">
              {{ record.category.name }}
            </span>
          </a-popover>
        </div>
        <template v-if="items.record.detail_level === 1">
          <a-popover>
            <template slot="content">
				<div v-if="record.description" v-html="record.description" class="iralex-entry-description"></div>
				<p v-else>-</p>
            </template>
            <!-- <div v-if="record.description" v-html="record.description" style="font-size: 11px; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; width: 25rem; text-align: left;"> -->
            <!-- </div> -->
			<div v-if="record.description" v-html="record.description" class="iralex-entry-description" style="font-size: 11px; display: -webkit-box; -webkit-box-orient: vertical; --num-lines: 3; -webkit-line-clamp: var(--num-lines); overflow: hidden;"></div>
			<small v-else>-</small>
          </a-popover>
        </template>
      </span>

      <span slot="discount_title" class="flex items-center gap-x-4">
        <p class="mb-0">Disc</p>
        <span v-if="isBillOld">(RM)</span>
        <a-select
          v-else-if="items.record.status === STATUS_DRAFT"
          v-model="discountType"
          @change="handleDiscountUnitChanged($event)"
          size="small"
          style="width: 5rem;"
        >
          <a-select-option :value="1">%</a-select-option>
          <a-select-option :value="2">{{ currencySymbol }}</a-select-option>
        </a-select>
      </span>
      <span slot="discount" slot-scope="text, record">
        <span v-if="isBillOld && items.record.status !== STATUS_DRAFT">-</span>
        <div v-else-if="items.record.status === STATUS_DRAFT" style="white-space: nowrap;">
          <a-input-number
            v-model="discountList[record.row - 1].input"
            :min="0"
            :max="((discountType === DISCOUNT_TYPE_PERCENTAGE) ? 100 : record.total)"
            @change="calculateDiscount(record.row - 1, (discountType === DISCOUNT_TYPE_PERCENTAGE) ? 100 : record.total)"
            :style="{width: (discountType === DISCOUNT_TYPE_PERCENTAGE) ? '5rem' : '150px'}"
            :formatter="discountFormatter"
            :parser="discountParser"
            :data-discount-no="record.row - 1"
            @focus="focusOnDiscountField(record.row - 1)"
          />
          <p v-if="discountType === DISCOUNT_TYPE_PERCENTAGE" class="inline-block ml-2 mb-0" style="width: 9rem;">
            {{ currencySymbol + discountList[record.row - 1].value.toFixed(2) }}
          </p>
        </div>
        <span v-else class="inline-block" style="width: 7rem;">
          {{ currencySymbol + (discountList[record.row - 1].value).toFixed(2) }}
        </span>
      </span>
      
    </a-table>

    <a-descriptions v-if="setting.templates !== undefined" :column="1" class="mt-5" layout="vertical">
      <a-descriptions-item v-if="setting.templates.description" label="Notes">
        <span v-html="setting.templates.description" class="word-note"></span>
      </a-descriptions-item>
    </a-descriptions>
  </div>
</template>

<script>
import mixin from '../../mixin/mixin'
import axios from '@/axios'

const STATUS_DRAFT    = 1 // This is the only status that allows editing the bill.
const STATUS_APPROVED = 2
const STATUS_UNPAID   = 3
const STATUS_PAID     = 4

const BILLING_TYPE_BILL         = 1
const BILLING_TYPE_FUND_REQUEST = 2

const DISCOUNT_TYPE_PERCENTAGE = 1
const DISCOUNT_TYPE_CURRENCY   = 2

const DEFAULT_TAX_RATE = 6

export default {
  name: "DescriptionTblBill",

  mixins: [mixin],

  props: {
    items: {
      type     : Object,
      required : true,
    },
    setting: {
      type     : Object,
      required : false,
    }
  },

  data() {
    return {
      // --- Constants
      // TODO(pooya): If you know a better pattern to handle constants in .vue
      // files, feel free to move these out.
      STATUS_DRAFT,
      STATUS_APPROVED,
      STATUS_UNPAID,
      STATUS_PAID,
      DISCOUNT_TYPE_PERCENTAGE,
      DISCOUNT_TYPE_CURRENCY,
      DEFAULT_TAX_RATE,
      BILLING_TYPE_BILL,
      BILLING_TYPE_FUND_REQUEST,

      // --- Reactive Data
      columns         : [],
      dataSource      : this.items.data.rows,
      tempTotal       : null,
      discountType    : DISCOUNT_TYPE_PERCENTAGE,
      discountList    : [], // an array of {input: number, value: number} objects
      loading         : false,
      total           : null,
      selectedRowKeys : [],
      selectAllChecked: false,

      // An old bill is one that was created before we switched to every time
      // entry having its own specific discount and tax. Back then, discount and
      // tax were applied to the sum of all entries. Unfortunately there's no
      // way to figure out how to find if a bill was created before this update,
      // so we do some f***ry in the created hook with the discounts to figure
      // this out and initialize isBillOld.
      isBillOld: undefined,
    }
  },

  computed: {
    listTable() {
      if (this.items && this.items.record) {
        if (this.items.record.type === 1) {
          if (this.dataSource && this.dataSource.length){
            const mergeArr = [...this.dataSource[0].time_entries,...this.dataSource[0].expense_entries]
            return mergeArr.map((item,i) => ({
              row            : i + 1,
              matter         : item.matter.title,
              description    : item.description,
              hoursQuantity  : item.duration || item.quantity,
              rate           : item.rate,
              total          : item.amount || (item.rate * item.duration),
              category       : item.category,
              id             : item.id,
            }))
          }
        } else {
          return [
            {
              row          : 1,
              matter       : this.items.record.matters && this.items.record.matters.length ? this.items.record.matters[0].title : '-',
              description  : this.items.record.note,
              hoursQuantity: '-',
              total        : this.items.record.total_amount,
            }
          ]
        }
      }
    },

    currencySymbol() {
      return localStorage.getItem('currency_symbol')
    },

    isBillTaxable() {
      return this.items.record.is_apply_tax
    },

    rowSelectionSettings() {
      if (this.items.record.type === BILLING_TYPE_FUND_REQUEST)
        return null
      else return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          this.isBillOld = false // Upon any change to the bill, we switch to the new version.
        },
        /* onSelect, onSelectAll */

        // NOTE(pooya): DO NOT REMOVE THIS FEATURE.
        // These two are currently commented out. It was used to select
        // taxable matters per time entry (currently you make them taxable per
        // matter).
        /* onSelect: (record, selected) => {
          var updateSelection = true

          this.setting.matter_taxes.forEach(tax => {
            if (record.row === tax.item_no && !tax.tax) {
              this.$message.error('This matter is not taxable.')
              updateSelection = false
            }
          })

          if (updateSelection)
          {
            if (selected) {
              this.selectedRowKeys.push(record.row - 1)
              this.selectAllChecked = true
            }
            else {
              const index = this.selectedRowKeys.indexOf(record.row - 1)
              if (index > -1) this.selectedRowKeys.splice(index, 1)
              if (this.selectedRowKeys.length === 0) this.selectAllChecked = false
            }
          }
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
          let showNotification = false
          this.selectedRowKeys = []

          if (this.selectAllChecked) {
            this.selectAllChecked = false
            return
          }

          this.setting.matter_taxes.forEach(tax => {
            selectedRows.forEach(row => {
              if (row.row === tax.item_no && tax.tax) {
                this.selectedRowKeys.push(row.row - 1)
                this.selectAllChecked = true
              }
              else showNotification = true
            })
          })

          if (showNotification) {
            this.$message.warning('Some matters were not taxable.')
          }
        }, */
        getCheckboxProps: (record) => ({
          props: {
            disabled: this.items.record.status !== STATUS_DRAFT,
            name: record.name,
          }
        }),
      }
    },

    discountFormatter() {
      if (this.discountType === DISCOUNT_TYPE_PERCENTAGE)
        return value => `${value}%`
      else
        return value => {
          if (Number(value))
            return `${this.currencySymbol} ${value}`
          else return `${this.currencySymbol} 0`
        }
    },

    discountParser() {
      if (this.discountType === DISCOUNT_TYPE_PERCENTAGE)
        return value => value.replace('%', '')
      else
        return value => value.replace(new RegExp(String.raw`${this.currencySymbol}\s`, "g"), '')
    },

    /**
     * Returns the final amount of the invoice in the currently
     * selected currency, taking tax and discount into account.
     * 
     * 
     * The following is a summary of the formula implemented here:
     * 
     *      Amount Per Row (If row is taxable)     : (amount-discount)*tax/100 + (amount-discount)
     *      Amount Per Row (If row is not taxable) : amount - discount
     *      Total Amount                           : ∑ amounts_per_row
     */
    amountDue() {
      const tax = (this.setting.tax !== undefined) ? this.setting.tax.rate : DEFAULT_TAX_RATE
      let returnValue = '0.00' // Error value when discounts aren't fetched from the server yet.

      if (this.items.record.type === BILLING_TYPE_FUND_REQUEST) {
        returnValue = this.listTable.reduce((result, el) => {
          return result + (el.total ? el.total : 0)
        }, 0).toFixed(2)
      }
      // It takes time to fetch the discounts from the server, and prior to
      // that, the discount list is an empty list.
      else if (this.discountList.length) {
        if (this.isBillOld) {
          const hasRowLength = this.items.data.rows.length
          const hasExpenseOrTimes = hasRowLength && (this.items.data.rows[0].expense_entries.length || this.items.data.rows[0].time_entries.length)
          const total = hasExpenseOrTimes ? this.totalAmountTimesExpense(this.dataSource[0]) : this.items.data.total
          const discount = Math.max(0, this.items.record.discount)
          let taxedAmount = 0
          if (this.items.record.is_apply_tax) taxedAmount = (total - discount) * (tax / 100)
          returnValue = (total - discount + taxedAmount).toFixed(2)
        }
        else {
          returnValue = this.listTable.reduce((result, el) => {
            const discount = Math.max(0, this.discountList[el.row - 1].value)
            if (this.selectedRowKeys.includes(el.row - 1))
              return result + (el.total ? (el.total - discount) * this.setting.tax.rate / 100 + (el.total - discount) : 0)
            else if (el.total) return result + el.total - discount
            else return result
          }, 0).toFixed(2)
        }
      }

      this.$emit('amountDueChanged', returnValue)
      return returnValue
    },

    totalTaxAmount() {
      if (this.items.record.type === BILLING_TYPE_FUND_REQUEST) {
        return '0.00'
      }
      else if (this.isBillOld) {
        let result = 0
        if (this.items.record.is_apply_tax) {
          result = this.listTable.reduce((sum, el) => {
            const amount = (el.total) ? el.total : 0
            return sum + el.total
          }, 0)
          result = (result - this.items.record.discount) * (this.setting.tax.rate / 100)
        }
        return result.toFixed(2)
      }
      else return this.listTable.reduce((result, el) => {
        if (this.selectedRowKeys.includes(el.row - 1))
          return result + (el.total ? (el.total - this.discountList[el.row - 1].value) * (this.setting.tax.rate / 100) : 0)
        else return result
      }, 0).toFixed(2)
    },

    /**
     * NOTE: Only used for display purposes. Not used in the actual calculations.
     */
    totalDiscountAmount() {
      if (this.items.record.type === BILLING_TYPE_FUND_REQUEST)
        return '0.00'
      else return this.discountList.reduce((sum, el) => sum + el.value, 0).toFixed(2)
    },
  },

  methods: {
    handleDiscountUnitChanged(value) {
      this.discountList = this.discountList.map(item => ({input: 0, value: 0}))
    },

    /**
     * Calculates the discounts for all time entries and time expenses.
     * Discount are calculated separately for each row.
     */
    calculateDiscount(row, max) {
      this.isBillOld = false // Upon any change to the bill, we switch to the new version.
      
      const clamp = (num, min, max) => Math.min(Math.max(num, min), max)
      
      if (!isNaN(this.discountList[row].input)) {
        // amount excluding discount and tax
        const amount = this.listTable[row].total
          // : (this.items.record.type === 1)
          // ? this.totalAmountTimesExpense(this.dataSource[0])
          // : this.items.data.total

        let discount = clamp(this.discountList[row].input, 0, max)
        if (this.discountType === DISCOUNT_TYPE_PERCENTAGE)
          discount = amount * discount / 100
        
        this.discountList[row].value = discount
      }
      else {
        this.discountList[row].value = 0
      }
    },

    /**
     * NOTE: Only used for display purposes. Not used in the actual calculations.
     * Only for the case where the billing is taxable.
     * 
     * DON'T REMOVE. NOT USED RIGTH NOW, BUT MIGHT BE REQUIRED LATER.
     */
    getTaxAmount(record) {
      const sum_expense = record.expense_entries.reduce((initial, item) => initial + item.amount, 0)
      const sum_times   = record.time_entries.reduce((initial, item) => initial + (item.rate * item.duration), 0)
      const sum = Number(sum_expense + sum_times) - this.items.record.discount
      return sum
    },

    async handleSubmitDiscount() {
      try {
        this.loading = true

        // This whole process of the following commented lines does not happen
        // anymore. This api used to update discount in the old bills. New bills
        // use the following much more sophisticated apis.
        // const { items: { record } } = this
        // const discount = (this.discountType === DISCOUNT_TYPE_PERCENTAGE) ? this.totalAmountTimesExpense(this.dataSource[0]) * this.discountAmount / 100 : this.discountAmount
        // const discount = (this.discountType === DISCOUNT_TYPE_PERCENTAGE && record.type === BILLING_TYPE_BILL) ? this.totalAmountTimesExpense(this.dataSource[0]) * this.discountAmount / 100 : this.total.discountAmount
        // await axios.put(`billing/${record.id}/`, { discount: Number(discount) })

        if (!this.isBillOld && this.items.record.type === BILLING_TYPE_BILL) {
          const taxPayload = this.setting.matter_taxes.map(item => ({
            // item_no: item.item_no,
            type: item.type,
            id: item.id,
            tax: this.selectedRowKeys.includes(item.item_no - 1),
          }))
          await axios.post(`billing/${this.items.record.id}/tax/`, { data: taxPayload })

          const discountPayload = this.setting.matter_taxes.map((item, ind) => {
            // this babel version does not support ?? operator
            const discount = Boolean(this.discountList[item.item_no - 1].input) ? this.discountList[item.item_no - 1].input : 0
            return {
              id: item.id,
              discount: (this.discountType === DISCOUNT_TYPE_PERCENTAGE) ? discount : 0,
              discount_cash: (this.discountType === DISCOUNT_TYPE_CURRENCY) ? discount : 0,
            }
          })
          await axios.post(`billing/${this.items.record.id}/discount/`, { data: discountPayload })
        }
        
        this.$emit('closeModal', true)
        this.$router.push('/billing')
      }
      catch (e) {
        this.$message.error('Server error')
        throw e
      }
      finally {
        this.loading = false
      }
    },

    focusOnDiscountField(recordNo) {
      const inputField = document.querySelector(`[data-discount-no='${recordNo}']`)
      inputField.children[1].children[0].select()
    },
  },

  created() {
    // ----- Initialize Discount List -----
    // 
    // This distinction between old and new billings is necessary because the
    // discount api used to be different for the old bills. The new discount api
    // is different, so we need to map them to the same interface.
    // 
    // Backend stores percentage of discount in el.discount, and the amount of
    // discount in el.discount_cash. So at a time, one is always null and one
    // always has a value.
    // 
    // The discount for old bills is stored inside "this.items.record.discount",
    // while the new discount api values come from "this.setting.discount_data".
    // The old api only had currency discount.
    // 
    // NOTE: This must be in created, not mounted, since it must be initialized
    // before being passed as v-model to input fields, or else, it's a Vue error.

    if (this.items.record.is_old_version) {
      this.isBillOld = true
      this.discountType = DISCOUNT_TYPE_CURRENCY
      this.discountList = this.setting.discount_data.map(el => {
        return { input: 0, value: 0 }
      })
      if (this.items.record.is_apply_tax)
        this.setting.matter_taxes.forEach(item => this.selectedRowKeys.push(item.item_no - 1))
    }
    else {
      this.isBillOld = false
      this.discountList = this.setting.discount_data.map(el => {
        if (el.discount !== null) {
          this.discountType = DISCOUNT_TYPE_PERCENTAGE
          return { input: el.discount, value: el.unit_amount * el.discount / 100 }
        }
        else if (el.discount_cash !== null) {
          this.discountType = DISCOUNT_TYPE_CURRENCY
          return { input: el.discount_cash, value: el.discount_cash }
        }
        else return { input: 0, value: 0 }
      })
    }
  },

  mounted() {
    // ----- Initialize Table Columns -----

    // These columns are always available, no matter the setting.
    const columns = [
      { title: 'Item No',          dataIndex: 'row',           key: '1' },
      { title: 'Matter',           dataIndex: 'matter',        key: '2', scopedSlots: { customRender: 'matter' } },
      { title: 'Description',      dataIndex: 'description',   key: '3', scopedSlots: { customRender: 'description' } },
    ]

    if (this.items.record.type === BILLING_TYPE_BILL) {
      columns.push(
        { title: 'Qty/Hr',           dataIndex: 'hoursQuantity', key: '4' },
        { title: 'Unit Price',       dataIndex: 'rate',          key: '5', scopedSlots: { customRender: 'price' } },
      )
    }

    columns.push(
      {
        title: (this.items.record.type === BILLING_TYPE_BILL) ? 'Amount Excl. Tax' : 'Amount',
        dataIndex: 'total',
        key: '6',
        scopedSlots: { customRender: 'amount' }
      }
    )

    if (this.items.record.type === BILLING_TYPE_BILL) {
      columns.push(
        {
          key: '7',
          slots: { title: 'discount_title' },
          scopedSlots: { customRender: 'discount' }
        },
        {
          title: `Tax Amount (${this.setting.tax.rate}% ${this.setting.tax.type})`,
          key: '8',
          scopedSlots: { customRender: 'taxed_amount' }
        },
        {
          key: '9',
          title: 'Amount Incl. Tax',
          scopedSlots: { customRender: 'amount_plus_taxed_amount' }
        },
      )
    }
    
    this.columns = columns

    // ----- Initialize Default Taxed Matters -----
    this.setting.matter_taxes.forEach(item => {
      if (item.tax) this.selectedRowKeys.push(item.item_no - 1)
    })
  }
}
</script>

<style>
  .tbl-header-temp .ant-table-footer {
    width: 50%;
    text-align: revert;
    margin-left: auto;
  }
  [dir] .description-bill-company .ant-descriptions-row > th, [dir] .ant-descriptions-row > td {
    padding-bottom: 0;
  }
  .description-bill-company .ant-descriptions-item-label {
    font-size: 12px;
  }
  .tbl-header-temp .ant-table-thead > tr > th, .ant-table-tbody > tr > td {
    overflow-wrap: anywhere;
  }
  .tbl-header-temp .ant-table-thead > tr > th {
    white-space: nowrap;
  }
  .word-note {
    white-space: break-spaces;
    word-break: break-all
  }
  .word-note p {
    margin-bottom: 0.25rem;
  }
  .tbl-header-temp .ant-table-tbody > tr > td {
    padding: 16px 10px !important;
  }
  .tbl-header-temp .ant-table-tbody > tr td:nth-child(5) , .tbl-header-temp .ant-table-tbody > tr td:nth-child(6) {
    white-space: nowrap;
  }

  .iralex-entry-description ul {
	padding-inline-start: 1rem;
	list-style-position: inside;
	list-style-type: disc;
  }
  .iralex-entry-description ol {
	padding-inline-start: 1rem;
	list-style-position: inside;
	list-style-type: decimal;
  }
</style>

<!--

http://localhost:8080/app/billing/dashboard/1707 (New, draft, has both time and expense)
http://localhost:8080/app/billing/dashboard/878  (Old, tax not applied, no discount, draft) R
?                                                (Old, tax not applied, no discount, approved)
http://localhost:8080/app/billing/dashboard/485  (Old, tax not applied, with discount, draft)
?                                                (Old, tax not applied, with discount, approved)
http://localhost:8080/app/billing/dashboard/838  (Old, tax applied, no discount, draft)
?                                                (Old, tax applied, no discount, approved)
?                                                (Old, tax applied, with discount, draft)
http://localhost:8080/app/billing/dashboard/416  (Old, tax applied, with discount, approved) R

http://localhost:8080/app/billing/dashboard/529  (Old, tax not applied, with discount, draft) (Test approving)
?                                                (Old, tax not applied, with discount, draft) (Test approving)
?                                                (Old, tax applied, no discount, draft) (Test approving)
?                                                (Old, tax applied, with discount, draft) (Test approving)

-->
